import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import axios from "axios";
import { API } from "../lib/api";
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "?")).get(
      "session_id"
    );

    if (!sessionId) {
      navigate("/login");
      return;
    }

    axios
      .get(`${API}/auth/session?session_id=${sessionId}`, {
        withCredentials: true,
      })
      .then((res) => {
        setUser(res.data);
        // Auto-resume: si el usuario inició el login con Google desde una
        // ruta protegida (sesión expirada → interceptor 401), volvemos
        // exactamente ahí en vez de tirarlo al dashboard genérico.
        let resumePath = null;
        try {
          resumePath = sessionStorage.getItem("startip_post_login_redirect");
          if (resumePath) sessionStorage.removeItem("startip_post_login_redirect");
        } catch { /* noop */ }
        const valid =
          resumePath &&
          resumePath.startsWith("/") &&
          !resumePath.startsWith("//") &&
          !resumePath.includes(":") &&
          !resumePath.startsWith("/login") &&
          !resumePath.startsWith("/register");
        if (valid && res.data.role !== "pending") {
          navigate(resumePath, { state: { user: res.data } });
          return;
        }
        if (res.data.role === "admin") {
          navigate("/admin", { state: { user: res.data } });
        } else if (res.data.role === "pending") {
          // New Google user: must choose creator or consumer before accessing the app
          navigate("/choose-role", { state: { user: res.data } });
        } else {
          navigate("/dashboard", { state: { user: res.data } });
        }
      })
      .catch(() => {
        navigate("/login");
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="animate-pulse text-neon-pink text-xl font-heading font-bold">
        Iniciando sesion...
      </div>
    </div>
  );
}
